import "bootstrap-icons/font/bootstrap-icons.css";
import { LinkButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";
import { InfoItem } from "components/pf";
import pf_form from "assets/pdf/property-financing/HF Application Form.pdf";
import pf_pds from "assets/pdf/property-financing/PDS-HF_effective28Nov2023.pdf";
import { handleOpenPdf } from "utils";
import { ASSETS_BASE_URL } from "constants";

function PropertyFinancingHome() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Property Financing-i"
          title={`  <span className="jumbotron-subtitle-2">
                Home
              </span>      
               Financing-<em>i</em>
             `}
          buttonText="Let's connect! "
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              alrajhi bank Malaysia Home Financing-<em>i</em> assist you to own
              your dream home with peace of mind.
            </p>
            <p>
              Looking to buy your dream home or refinance your existing
              property? Enjoy attractive rate from as low as 3.9%* p.a. with our
              easy, stress-free Home financing-<em>i </em>
              packages. (*Terms and conditions apply)
            </p>
            {/* <img
              style={{ width: "100%" }}
              src={currency}
              className="d-inline-block align-top"
              alt=""
            /> */}
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">
                  Competitive Financing Rate
                </div>
                <div className="column-subheader-2">
                  Financing Rate as low as <b>3.9%* p.a.</b> (*Terms &
                  Conditions Apply){" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Financing</div>
                <div className="column-subheader-2">
                  Margin of financing up to 90%{" "}
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Tenure</div>
                <div className="column-subheader-2">
                  Tenures of up to 35 years{" "}
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Takaful Coverage</div>
                <div className="column-subheader-2">
                  Comprehensive Takaful coverage provided{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Available Package</div>
                <div className="column-subheader-2">
                  Zero entry cost package available
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Shariah Contract</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Shariah Contract</div>
                <div className="column-subheader-2">
                  Commodity Murabahah (via Tawarruq arrangement)
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Requirements</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-5 col-12 custom-column">
                <div className="column-header-2">Salaried Employees: </div>
                <div className="column-subheader pt-3">
                  <li>
                    Photocopy of <b>IC / Identification document</b>
                  </li>
                  <li>
                    Latest 3 months <b>latest 3 months salary slip</b> and{" "}
                    <b>bank statement showing salary credited</b>
                  </li>
                  <li>
                    Latest <b>EPF statement</b>
                  </li>
                  <li>
                    Sales & <b>Purchase Agreement</b> / Booking receipt
                    <li>
                      <b>Property Title</b>
                    </li>
                  </li>
                </div>
              </div>
              <div className="col-xl-5 col-12 custom-column">
                <div className="column-header-2">Self-employed:</div>
                <div className="column-subheader pt-3">
                  <li>
                    Photocopy of <b>IC / Identification document</b>
                  </li>
                  <li>
                    Latest 6 months <b>bank statement</b>
                  </li>
                  <li>
                    <b>Business registration Form</b>
                  </li>
                  <li>
                    Copy of <b>Income Tax</b> & proof of tax payment
                  </li>
                  <li>
                    Sales & <b>Purchase Agreement</b> / Booking receipt
                    <li>
                      <b>Property Title</b>
                    </li>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Fees & Charges</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <InfoItem
                header="Retrieval / Photocopy of Security Documents"
                subheader="Actual Cost"
              />
              <InfoItem
                header="EPF Withdrawal Confirmation Letter Fee"
                subheader="RM10.00 per request"
              />

              <InfoItem
                header="Annual Financing Statement Fee"
                subheader="RM 5.00 per request (Ad-hoc)"
              />
              <InfoItem
                header="Redemption Statement Fee"
                subheader="RM 10.00 per request"
              />
              <InfoItem
                header="Brokerage Fee"
                subheader="0.0008% of the principal amount of financing/disbursement"
              />
              <InfoItem
                header="ARNT Fee (or Agency Fee)"
                subheader="RM 1.00 per transaction"
              />
            </div>
            <div className="link-button-row pt-5">
              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() => handleOpenPdf(pf_pds)}
              />
              <LinkButton
                text="Download Application Form"
                onClick={() =>
                  handleOpenPdf(
                    `${ASSETS_BASE_URL}assets/pdf/personal-financing/HF_Application_Form.pdf `
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Let's connect! </h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
      {/* <MainFooter />
      <SubFooter /> */}
    </div>
  );
}

export default PropertyFinancingHome;
